import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=74543f4a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74543f4a')) {
      api.createRecord('74543f4a', component.options)
    } else {
      api.reload('74543f4a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=74543f4a&", function () {
      api.rerender('74543f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v7yTtA7zCrv9/JS/comp/openstreetmap.vue"
export default component.exports